import { useEffect } from 'react';
import { useNavigate, useRouterState } from '@tanstack/react-router';
import { useAuth } from '../../auth/useAuth';
import { useSubscriptions } from './api';

const SELECT_PATH = '/mailboxes';

/**
 * Пока активная подписка не выбрана, BFF шлёт в temp-email-api `X-Account-Id` = `sub`, то есть
 * личный аккаунт без подписки: пользователь видит ящики и лимиты из конфигурации стенда вместо
 * тарифных (promt-85). Экран выбора нельзя вешать только на `/callback` — федеративный переход
 * из ЕЛК приходит на `/auth/login?returnUrl=/` и минует его, поэтому проверка живёт в layout и
 * срабатывает на любой точке входа.
 */
export function useSubscriptionSelectionGuard(): void {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const { data } = useSubscriptions(isAuthenticated);

  const needsSelection = (data?.items.length ?? 0) > 1 && !data?.activeSubscriptionId;

  useEffect(() => {
    if (!needsSelection) return;
    if (pathname === SELECT_PATH || pathname === `${SELECT_PATH}/` || pathname === '/callback') return;
    if (pathname.startsWith('/subscriptions/')) return;
    void navigate({ to: SELECT_PATH });
  }, [needsSelection, pathname, navigate]);
}
